import { consoleLayout, type ConsoleLayout } from '../utilities/nativeApp'

/**
 * The console inside the noBGP iOS and Android apps (mobile/). The layout is read once: the user
 * agent does not change while the page lives.
 */
export const layout: ConsoleLayout = typeof navigator === 'undefined' ? 'web' : consoleLayout(navigator.userAgent)

/** Inside the app, phone or tablet. */
export const inNativeApp = layout !== 'web'

/** Inside the app on a phone: the drawer is the whole screen and there is no graph. */
export const isNativePhone = layout === 'phone'

type CapacitorBridge = {
  nativePromise?: (
    plugin: string,
    method: string,
    options?: Record<string, unknown>
  ) => Promise<Record<string, unknown>>
}

/**
 * Calls a native plugin of the app (the shell's NobgpShell, @capacitor/push-notifications,
 * @capacitor/share). The console does not bundle @capacitor/core: the app injects the bridge into
 * the page, and this is its low-level entry, the one mobile/www/nobgp-shell.js uses too.
 * Rejects outside the app.
 */
export const nativeCall = <T = Record<string, unknown>>(
  plugin: string,
  method: string,
  options: Record<string, unknown> = {}
): Promise<T> => {
  const cap = (window as unknown as { Capacitor?: CapacitorBridge }).Capacitor
  if (!inNativeApp || !cap?.nativePromise) return Promise.reject(new Error('not in the noBGP app'))
  return cap.nativePromise(plugin, method, options) as Promise<T>
}
